<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header
    class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Agenda</p>
      <h1 class="text-2xl font-semibold leading-tight">Visualização da agenda</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Veja os agendamentos por dia, navegue entre as semanas e abra detalhes ou crie novos horários.
      </p>
    </div>
    <div class="grid grid-cols-2 gap-3 text-sm md:grid-cols-2">
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Dias exibidos</p>
        <strong class="text-lg">{{ cabecalhoAgenda.length || 0 }}</strong>
      </div>
      <div class="rounded-xl bg-white/10 px-4 py-3 shadow">
        <p class="m-0 text-xs uppercase tracking-[0.12em] text-light-color/80">Agendamentos</p>
        <strong class="text-lg">{{ agendamentos.length || 0 }}</strong>
      </div>
    </div>
  </header>

  <section class="flex flex-col gap-4 rounded-xl border border-border-color bg-white px-5 py-5 shadow-[0_12px_36px_var(--box-shadow-color)]">
    <div class="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div class="flex items-center gap-2 text-sm text-dark-color">
        <i class="fa-regular fa-calendar text-lg"></i>
        <span>Calendário semanal</span>
      </div>
      <div class="flex flex-wrap gap-2">
        <button
          type="button"
          (click)="handleBackPage()"
          class="inline-flex items-center gap-2 rounded-base border border-border-color bg-white px-4 py-2 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color">
          <i class="fa fa-arrow-left"></i>
          Voltar
        </button>
        <input
          type="date"
          class="rounded-base border border-border-color bg-white px-4 py-2 text-sm text-dark-color shadow-sm outline-none focus:border-primary-color" />
        <select
          class="rounded-base border border-border-color bg-white px-4 py-2 text-sm text-dark-color shadow-sm outline-none focus:border-primary-color">
          <option value="">Todos os status</option>
          <option value="confirmed">Confirmado</option>
          <option value="pending">Pendente</option>
          <option value="cancelled">Cancelado</option>
        </select>
      </div>
    </div>

    <div class="rounded-xl border border-border-color bg-white shadow overflow-hidden">
      <div class="flex items-center justify-between border-b border-border-color px-4 py-3">
        <div class="flex items-center gap-2 text-sm font-semibold text-dark-color">
          <button
            type="button"
            class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color"
            (click)="navegarEsquerda()">
            <i class="fa-solid fa-chevron-left"></i>
          </button>
          <div class="flex items-center gap-2">
            <span *ngFor="let dia of cabecalhoAgenda; let i = index" class="text-xs">
              <span class="hidden md:inline">{{ dia | date : 'EEE' | uppercase }}</span>
              <span class="font-semibold">{{ dia | date : 'dd/MM' }}</span>
              <span *ngIf="i !== cabecalhoAgenda.length - 1" class="mx-1 text-border-color">•</span>
            </span>
          </div>
          <button
            type="button"
            class="flex h-9 w-9 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color"
            (click)="navegarDireita()">
            <i class="fa-solid fa-chevron-right"></i>
          </button>
        </div>
        <span class="text-sm text-dark-color/70">Período {{ cabecalhoAgenda[0] | date : 'dd/MM' }} - {{ cabecalhoAgenda[cabecalhoAgenda.length-1] | date : 'dd/MM' }}</span>
      </div>

      <div class="min-h-[240px]">
        <ng-container *ngIf="isLoadingAgendamentos; else calendario">
          <div class="flex w-full items-center justify-center py-10">
            <span class="h-8 w-8 animate-spin rounded-full border-2 border-border-color border-t-primary-color"></span>
          </div>
        </ng-container>

        <ng-template #calendario>
          <div class="grid grid-cols-7 divide-x divide-border-color">
            <div
              *ngFor="let dia of cabecalhoAgenda"
              class="flex min-h-[200px] flex-col gap-2 p-3">
              <div class="rounded-lg bg-light-color px-3 py-2 text-center text-sm font-semibold text-dark-color">
                {{ dia | date : 'EEE dd/MM' | uppercase }}
              </div>

              <ng-container *ngIf="filtrarPorData(agendamentos, dia) as agendamentosDia">
                <ng-container *ngFor="let time of agendamentosDia; trackBy: trackByHora">
                  <ng-container *ngIf="time.agendamento?.length > 0; else slotLivre">
                    <div
                      class="cursor-pointer rounded-lg border border-primary-color/30 bg-primary-color/5 p-2 transition hover:border-primary-color"
                      (click)="handleOpenModalAppointment(time)">
                      <div
                        *ngFor="let agendamento of time.agendamento; let i = index"
                        class="mb-2 rounded-lg border border-border-color bg-white p-2 text-sm shadow-sm last:mb-0">
                        <div class="flex items-center justify-between gap-2 text-dark-color">
                          <span class="font-semibold">{{ formatNameClient(agendamento?.clientName) }}</span>
                          <span class="text-xs font-mono text-dark-color/70">{{ time.time }}</span>
                        </div>
                        <div
                          class="mt-2 inline-flex items-center gap-1 rounded-full px-2 py-1 text-[11px] font-semibold text-white"
                          [ngClass]="{
                            'bg-green-500': agendamento?.status === 'confirmed',
                            'bg-yellow-500': agendamento?.status === 'scheduled',
                            'bg-red-500': agendamento?.status === 'canceled',
                            'bg-gray-800': agendamento?.status === 'rescheduled',
                            'bg-blue-500': agendamento?.status === 'in_progress',
                            'bg-purple-500': agendamento?.status === 'completed',
                            'bg-orange-500': agendamento?.status === 'no_show'
                          }">
                          {{ getStatusEnum(agendamento?.status) }}
                          <span *ngIf="i > 0" class="ml-1 rounded bg-white/20 px-2 py-0.5 text-[10px] font-semibold uppercase">Encaixe</span>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #slotLivre>
                    <button
                      type="button"
                      class="flex flex-col items-center justify-center rounded-lg border border-dashed border-border-color bg-light-color px-3 py-4 text-center text-sm font-semibold text-dark-color transition hover:border-primary-color"
                      (click)="handleOpenModalAppointment(time)">
                      {{ time.time }}
                      <span class="text-xs font-normal text-dark-color/70">Disponível</span>
                    </button>
                  </ng-template>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </section>
</div>

<ng-container *ngIf="openModalAppointment">
  <app-view-agendamento
    (closeModalAppointment)="handleCloseModalAppointment()"
    [objectData]="appointmentSelected"
    [arrFittings]="arrFittings"
    (updateDataAppointment)="handleRechargeAppointments()"
  ></app-view-agendamento>
</ng-container>
<ng-container *ngIf="openModalNewAppointment">
  <app-criar-agendamento
    (closeModal)="handleCloseModalAppointment()"
    (concluedAppointmentRegister)="handleRechargeAppointments()"
    [scheduleId]="scheduleId"
    [infoTime]="infoAppointmentCreate"
  ></app-criar-agendamento>
</ng-container>
